/**
 * 소식 · 케어 모달의 작성자 칸 (template-parts/partner-author.php) — 이 매장 / 공통(통합 계정).
 *
 * 새 글에서만 고른다. 고칠 때는 그 글의 작성자로 맞추고 잠근다(작성자는 바꾸지 않는다).
 * 공통을 고르면 공통 글이 보이지 않는 매장 경고를 띄운다. 칸이 없는 화면(원장 계정)에서는 아무것도 하지 않는다.
 */

const createAuthorField = (form) => {
  const field = form.querySelector('[data-partner-author]');
  const radios = field ? Array.from(field.querySelectorAll('input[name="author"]')) : [];
  const note = field?.querySelector('[data-partner-author-note]');
  // PHP 가 공통을 막아 둔 매장(아이디 규칙)이면 새 글에서도 계속 막는다
  const sharedBlocked = radios.some((radio) => 'shared' === radio.value && radio.disabled);

  const value = () => radios.find((radio) => radio.checked)?.value || 'shop';

  const syncNote = () => {
    if (note) {
      note.hidden = 'shared' !== value() || radios.every((radio) => radio.disabled);
    }
  };

  radios.forEach((radio) => radio.addEventListener('change', syncNote));

  /** 새 글 — 이 매장으로 되돌리고 고를 수 있게 */
  const reset = () => {
    radios.forEach((radio) => {
      radio.checked = 'shop' === radio.value;
      radio.disabled = 'shared' === radio.value && sharedBlocked;
    });
    syncNote();
  };

  /** 고칠 글 — 그 글의 작성자로 맞추고 잠근다 */
  const lock = (shared) => {
    radios.forEach((radio) => {
      radio.checked = (shared ? 'shared' : 'shop') === radio.value;
      radio.disabled = true;
    });
    syncNote();
  };

  return { value, reset, lock };
};

export default createAuthorField;
